/**
 * Makes card expiration date look like "01/24"
 * @param {string} value Parsed value
 * @param {Object} obj
 * @param {Object} obj.max Maximum amount of symbols
 */
const normalizeCardExpirationDate = (
  value: string,
  { max }: { max: number } = { max: 5 }, // 5 or 7
): string =>
  value
    /** remove all non-numbers (incl. spaces) */
    .replace(/\D+/g, "")
    /** makes two groups:
     * 1) two characters at the start
     * 2) rest
     * */
    .match(/(^.{1,2})|(.+)/g)
    /** join groups by "/" */
    ?.join("/")
    /** limit by "MAX" symbols, like "01/32" */
    ?.substring(0, max) || "";

export default normalizeCardExpirationDate;
